import Axios from "axios";

const apiInstance = Axios.create();

apiInstance.interceptors.response.use(
  response => response,
  err => {
    const responseMessage = err?.response?.data?.message;
    const status = err?.response?.status;

    // Network / CORS / timeout / aborted: no `response` available at all.
    if (!err?.response) {
      const networkError = new Error(err?.message || "networkError");
      (networkError as Error & {response?: unknown; status?: number; code?: string}).response = err?.response;
      (networkError as Error & {status?: number}).status = status;
      (networkError as Error & {code?: string}).code = err?.code;
      return Promise.reject(networkError);
    }

    if (!responseMessage || err.code === "ERR_BAD_RESPONSE") {
      const fallback = new Error("internalError");
      (fallback as Error & {response?: unknown}).response = err.response;
      (fallback as Error & {status?: number}).status = status;
      return Promise.reject(fallback);
    }

    const wrapped = new Error(responseMessage);
    (wrapped as Error & {response?: unknown}).response = err.response;
    (wrapped as Error & {status?: number}).status = status;
    return Promise.reject(wrapped);
  }
);

export default apiInstance;
